export const CookieNames = {
    TOCH_USER_EMAIL: 'tochUserEmail',
    TOCH_USER_DATA: 'tochUserData',
    TOCH_USER_MEMBERSHIPS: 'tochUserMemberships',
    UserId: 'userId',
};
